import React, { useEffect, useState } from "react";
import { Input } from "../../Helpers/Input/Input";
import trans, { isRTL } from "../../../utils";
import usePermission from "../../../hooks/usePermission";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
function PasswordValidation({ password }) {
	const DEFAULT_COLOR = "#AEB5C1";
	const SUCCESS_COLOR = "#2E9245";
	const ERROR_COLOR = "#CF1322";

	const [validation, setValidation] = useState([
		{
			key: 1,
			title: "Password must be at least 12 characters long",
			color: "#AEB5C1",
			valid: null,
		},
		{
			key: 2,
			title: "Password must contain at least one uppercase letter",
			color: "#AEB5C1",
			valid: null,
		},
		{
			key: 3,
			title: "Password must contain at least one digit",
			color: "#AEB5C1",
			valid: null,
		},
		{
			key: 4,
			title: "Password must contain at least one special character",
			color: "#AEB5C1",
			valid: null,
		},
	]);
	useEffect(() => {
		const updatedValidation = validation.map((rule) => {
			let isValid = null;

			if (password?.length > 0) {
				switch (rule.key) {
					case 1:
						isValid = password.length >= 12;
						break;
					case 2:
						isValid = /[A-Z]/.test(password);
						break;
					case 3:
						isValid = /\d/.test(password);
						break;
					case 4:
						isValid = /[!@#$%^&*(),.?":{}|<>]/.test(password);
						break;
					default:
						isValid = null;
				}
			}

			return {
				...rule,
				valid: isValid,
				color:
					isValid === null
						? DEFAULT_COLOR
						: isValid
							? SUCCESS_COLOR
							: ERROR_COLOR,
			};
		});

		setValidation(updatedValidation);
	}, [password]);

	return (
		<div>
			{validation?.map((i) => (
				<div key={i.key} className="d-flex align-items-center mb-2">
					<span
						style={{
							width: "18px",
							height: "18px",
							borderRadius: "50%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontSize: "10px",
							backgroundColor: i.color,
							marginLeft: isRTL && "6px",
							marginRight: !isRTL && "6px",
						}}
					>
						{i.valid === null ? (
							<CheckOutlined style={{ color: "white" }} />
						) : i.valid ? (
							<CheckOutlined style={{ color: "white" }} />
						) : (
							<CloseOutlined style={{ color: "white" }} />
						)}
					</span>

					<div style={{ color: i.color, fontWeight: "400", fontSize: "12px" }}>
						{trans(i.title)}
					</div>
				</div>
			))}
		</div>
	);
}
export default function AccountPassword({ inf, setDisabled, disable }) {
	const { edit } = usePermission("SETUPACCOUNT");

	return (
		<div className="account-layout my-3">
			<div>
				<div className="account-layout-head">{trans("Password")}</div>
				<p className="account-layout-title">{trans("Update your password")}</p>
				<div className="row">
					<div className="col-lg-12">
						<Input
							title={trans("New Password")}
							formstyle="form-input"
							type="password"
							placeholder="********"
							id="password"
							name="password"
							onBlur={inf.handleBlur}
							disabled={!edit}
							onChange={inf.handleChange}
						/>
					</div>

					<div className="col-lg-12">
						<Input
							title={trans("Confirm Password")}
							formstyle="form-input"
							type="password"
							id="confirmPassword"
							name="confirmPassword"
							placeholder="********"
							onChange={inf.handleChange}
							onBlur={inf.handleBlur}
							errors={inf.errors.confirmPassword}
							touched={inf.touched.confirmPassword}
							value={inf.values.confirmPassword || ""}
							disabled={!inf.values.password}
						/>
					</div>
					{<PasswordValidation password={inf.values.password} />}
				</div>
			</div>
		</div>
	);
}
